<template>
  <div class="change-password-page">
    <div class="a-header">
      <span class="a-header--title">Manage Credentials</span>
    </div>
    <div class="a-header2">
      <span class="a-header2--title">Change Password</span>
    </div>
    <change-password/>
    <div class="a-header2">
      <span class="a-header2--title">Two-Factor Authentication (2FA) </span>
    </div>
    <two-factor-auth/>
    <template v-if="featureAccess && featureAccess['api-key']">
      <div class="a-header2">
        <span class="a-header2--title">Create API Token</span>
      </div>
      <a
        class="cred-docs-link"
        href="https://docs.weborion.io/api-reference/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <a-icon type="book" class="cred-docs-link__icon" />
        <span class="cred-docs-link__title">API reference</span>
        <span class="cred-docs-link__desc">Endpoints &amp; examples for the WebOrion API</span>
        <a-icon type="arrow-right" class="cred-docs-link__arrow" />
      </a>
      <apikey/>
    </template>
  </div>
</template>

<script>
  import AccountService from '../services/account.service';
  import ChangePassword from './ChangePassword.vue';
  import APIKey from './APIKey.vue';
  import TwoFactorAuth from './TwoFactorAuth.vue';

  export default {
    components: {
      'change-password': ChangePassword,
      'apikey': APIKey,
      'two-factor-auth': TwoFactorAuth
    },
    computed: {
      featureAccess() {
        return this.$store.state.user.data.feature_access;
      }
    },
    // If password change is required, don't let users leave the page without changing password
    // Except for the "/login" page (for logout)
    async beforeRouteLeave(to, from, next) {
      //console.log("leaving route", from, to);

      // User is logging out, we always allow this and skip the checking of user info
      if (to.path === "/login") {
        next();
        return;
      }

      let loggedInUserData = await AccountService.getUser();
      if (loggedInUserData && loggedInUserData.force_change_password_on_login) {
        this.$error({
          title: 'Password Change Required',
          content: 'You must change your password before you can access the portal',
        });
        next(false);
      } else {
        next();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .change-password-page {
    .ant-form label::before {
      display: none;
    }
    .a-footer .ant-btn {
      min-width: 120px;
    }
  }
  .a-header2--title{
    font-size: 16px;
    font-weight: 500;
    color: #151b22;
    padding-bottom: 10px;
  }
  // Sits below the section title, indented to line up with the panel content.
  .cred-docs-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 2px 0 0 30px;
    font-size: 12.5px;
    color: #858688;
    text-decoration: none;
    transition: color 120ms ease;
    .cred-docs-link__icon {
      color: #20a4b8;
      font-size: 15px;
    }
    .cred-docs-link__title {
      color: #151b22;
      font-weight: 600;
    }
    .cred-docs-link__arrow {
      font-size: 11px;
      opacity: 0.7;
      transform: rotate(-45deg);
    }
    &:hover {
      color: #20a4b8;
      .cred-docs-link__title {
        color: #20a4b8;
      }
    }
  }
  .a-header2{
    height: 45px;
    min-height: 40px;
    line-height: 60px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 20px;
    padding-left: 10px;
  }
</style>
